import { useSearchParams } from 'react-router-dom';

const useReferer = () => {
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref');
  if (ref) return ref;
};

export default useReferer;
